import { WEEKDAYS } from '../enum/weekday'

// matches url with either http/https protocol - https://stackoverflow.com/a/3809435
export const validUrl = new RegExp(
  /https?:\/\/(www\.)?[\w#%.:=@~-]{1,256}\.[\d()a-z]{1,6}\b([\w#%&()./:=?@~-]*)?/i
)

export const NUMBER_OF_LIST_PER_PAGE: string[] = [
  '10',
  '25',
  '50',
  '100',
  '200'
]

export const gender: { label: string; value: Gender }[] = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
  { label: 'Non-Binary', value: 'non_binary' },
  { label: 'Other', value: 'others' },
  { label: 'Prefer not Sharing', value: 'prefer_not_to_share' }
]

export const payScale: { label: string; value: string }[] = [
  { label: '₹ 0.3-0.5 per word', value: '0.3-0.5' },
  { label: '₹ 0.5-0.7 per word', value: '0.5-0.7' },
  { label: '₹ 0.7-0.9 per word', value: '0.7-0.9' },
  { label: '₹ 0.9-1.2 per word', value: '0.9-1.2' },
  { label: '₹ 1.2-1.5 per word', value: '1.2-1.5' },
  { label: '₹ 1.5-2.0 per word', value: '1.5-2.0' },
  { label: '₹ 2.0-4.0 per word', value: '2.0-4.0' },
  { label: '₹ 4.0-6.0 per word', value: '4.0-6.0' },
  { label: '₹ 6.0-9.0 per word', value: '6.0-9.0' },
  { label: '₹ 9.0-12.0 per word', value: '9.0-12.0' },
  { label: '₹ 12.0-15.0 per word', value: '12.0-15.0' },
  { label: '₹ 15.0 and above per word', value: '15.0 and above' }
]

export const query: { label: string; value: ThreadType }[] = [
  { label: 'Brief Query', value: 'brief' },
  { label: 'Rework Query', value: 'rework' },
  { label: 'Deadline Query', value: 'deadline' },
  { label: 'Other', value: 'other' }
]

export const week: { label: string; value: number }[] = Object.values(
  WEEKDAYS
).map(_week => ({ label: _week.title, value: _week.id }))

export const freelancerType: { label: string; value: string }[] = [
  { label: 'Full Time', value: 'full-time' },
  { label: 'Part Time', value: 'part-time' }
]

export const creatorPassReason = [
  { value: 'short_deadline', label: 'Short Deadline' },
  {
    value: 'not_preferred_genre',
    label: 'Not Preferred Genre'
  },
  {
    value: 'prior_commitments',
    label: 'Prior Commitments'
  },
  { value: 'other', label: 'Other' }
]

export const wordCount: { label: string; value: string }[] = [
  { label: 'Upto 500', value: '500' },
  { label: 'Upto 1000', value: '1000' },
  { label: 'Upto 2500', value: '2500' },
  { label: 'Upto 5000', value: '5000' },
  { label: 'Upto 10000', value: '10000' }
]

export const headlinePurpose: { label: string; value: string }[] = [
  { label: 'Informational', value: 'informational' },
  { label: 'Promotional', value: 'promotional' },
  { label: 'News', value: 'news' },
  { label: 'Product release', value: 'product_release' },
  { label: 'Event/Invitation', value: 'event/Invitation' }
]

export const platforms: { label: string; value: string }[] = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Linkedin', value: 'linkedin' }
]

export const experienceLevel = [
  { id: '1', title: 'Generic Writer' },
  { id: '2', title: 'Advance Writer' },
  { id: '3', title: 'Subject Matter Expert' }
]

export const translatorExperienceLevel = [
  { value: '1', label: 'Entry Level' },
  { value: '2', label: 'Regional' },
  { value: '3', label: 'Language Expert' }
]

export const designerExperienceLevel = [
  {
    id: '2',
    title: 'Experience ($)'
  },
  {
    id: '3',
    title: 'Professional ($$)'
  }
]

export const otherCategoryExperienceLevel = [
  {
    id: '1',
    title: 'Competent'
  },
  {
    id: '2',
    title: 'Proficient'
  },
  {
    id: '3',
    title: 'Expert'
  }
]

export const hearAboutPepper = [
  { label: 'Facebook / Instagram', value: 'Facebook / Instagram' },
  { label: 'Naukri.com', value: 'Naukri.com' },
  { label: 'Youtube', value: 'Youtube' },
  { label: 'Twitter', value: 'Twitter' },
  { label: 'Referral', value: 'Referral' },
  { label: 'I found it on my own', value: 'I found it on my own' },
  { label: 'Others', value: 'Others' }
]

export const workExperience = [
  { label: '0-1 year', value: '0' },
  { label: '1 year', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
  { label: '4 years', value: '4' },
  { label: '5 years', value: '5' },
  { label: '6 years', value: '6' },
  { label: '7 years', value: '7' },
  { label: '8 years', value: '8' },
  { label: '9 years', value: '9' },
  { label: '10+ years', value: '10+' }
]

export const countries: { label: string; value: string }[] = [
  {
    label: 'Albania',
    value: 'Albania'
  },
  {
    label: 'Antarctica',
    value: 'Antarctica'
  },
  {
    label: 'Argentina',
    value: 'Argentina'
  },
  {
    label: 'American Samoa',
    value: 'American Samoa'
  },
  {
    label: 'Austria',
    value: 'Austria'
  },
  {
    label: 'Australia',
    value: 'Australia'
  },
  {
    label: 'Aruba',
    value: 'Aruba'
  },
  {
    label: 'Aland Islands',
    value: 'Aland Islands'
  },
  {
    label: 'Azerbaijan',
    value: 'Azerbaijan'
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina'
  },
  {
    label: 'Barbados',
    value: 'Barbados'
  },
  {
    label: 'Bangladesh',
    value: 'Bangladesh'
  },
  {
    label: 'Belgium',
    value: 'Belgium'
  },
  {
    label: 'Burkina Faso',
    value: 'Burkina Faso'
  },
  {
    label: 'Bulgaria',
    value: 'Bulgaria'
  },
  {
    label: 'Bahrain',
    value: 'Bahrain'
  },
  {
    label: 'Burundi',
    value: 'Burundi'
  },
  {
    label: 'Benin',
    value: 'Benin'
  },
  {
    label: 'Saint Barthelemy',
    value: 'Saint Barthelemy'
  },
  {
    label: 'Bermuda',
    value: 'Bermuda'
  },
  {
    label: 'Brunei',
    value: 'Brunei'
  },
  {
    label: 'Bolivia',
    value: 'Bolivia'
  },
  {
    label: 'Bonaire, Saint Eustatius and Saba',
    value: 'Bonaire, Saint Eustatius and Saba'
  },
  {
    label: 'Brazil',
    value: 'Brazil'
  },
  {
    label: 'Bahamas',
    value: 'Bahamas'
  },
  {
    label: 'Bhutan',
    value: 'Bhutan'
  },
  {
    label: 'Bouvet Island',
    value: 'Bouvet Island'
  },
  {
    label: 'Botswana',
    value: 'Botswana'
  },
  {
    label: 'Belarus',
    value: 'Belarus'
  },
  {
    label: 'Belize',
    value: 'Belize'
  },
  {
    label: 'Canada',
    value: 'Canada'
  },
  {
    label: 'Cocos Islands',
    value: 'Cocos Islands'
  },
  {
    label: 'Democratic Republic of the Congo',
    value: 'Democratic Republic of the Congo'
  },
  {
    label: 'Central African Republic',
    value: 'Central African Republic'
  },
  {
    label: 'Republic of the Congo',
    value: 'Republic of the Congo'
  },
  {
    label: 'Switzerland',
    value: 'Switzerland'
  },
  {
    label: 'Ivory Coast',
    value: 'Ivory Coast'
  },
  {
    label: 'Cook Islands',
    value: 'Cook Islands'
  },
  {
    label: 'Chile',
    value: 'Chile'
  },
  {
    label: 'Cameroon',
    value: 'Cameroon'
  },
  {
    label: 'China',
    value: 'China'
  },
  {
    label: 'Colombia',
    value: 'Colombia'
  },
  {
    label: 'Costa Rica',
    value: 'Costa Rica'
  },
  {
    label: 'Cuba',
    value: 'Cuba'
  },
  {
    label: 'Cape Verde',
    value: 'Cape Verde'
  },
  {
    label: 'Curacao',
    value: 'Curacao'
  },
  {
    label: 'Christmas Island',
    value: 'Christmas Island'
  },
  {
    label: 'Cyprus',
    value: 'Cyprus'
  },
  {
    label: 'Germany',
    value: 'Germany'
  },
  {
    label: 'Djibouti',
    value: 'Djibouti'
  },
  {
    label: 'Denmark',
    value: 'Denmark'
  },
  {
    label: 'Dominica',
    value: 'Dominica'
  },
  {
    label: 'Dominican Republic',
    value: 'Dominican Republic'
  },
  {
    label: 'Algeria',
    value: 'Algeria'
  },
  {
    label: 'Ecuador',
    value: 'Ecuador'
  },
  {
    label: 'Estonia',
    value: 'Estonia'
  },
  {
    label: 'Egypt',
    value: 'Egypt'
  },
  {
    label: 'Western Sahara',
    value: 'Western Sahara'
  },
  {
    label: 'Eritrea',
    value: 'Eritrea'
  },
  {
    label: 'Spain',
    value: 'Spain'
  },
  {
    label: 'Ethiopia',
    value: 'Ethiopia'
  },
  {
    label: 'Finland',
    value: 'Finland'
  },
  {
    label: 'Fiji',
    value: 'Fiji'
  },
  {
    label: 'Falkland Islands',
    value: 'Falkland Islands'
  },
  {
    label: 'Micronesia',
    value: 'Micronesia'
  },
  {
    label: 'Faroe Islands',
    value: 'Faroe Islands'
  },
  {
    label: 'France',
    value: 'France'
  },
  {
    label: 'Gabon',
    value: 'Gabon'
  },
  {
    label: 'United Kingdom',
    value: 'United Kingdom'
  },
  {
    label: 'Grenada',
    value: 'Grenada'
  },
  {
    label: 'Georgia',
    value: 'Georgia'
  },
  {
    label: 'French Guiana',
    value: 'French Guiana'
  },
  {
    label: 'Guernsey',
    value: 'Guernsey'
  },
  {
    label: 'Ghana',
    value: 'Ghana'
  },
  {
    label: 'Gibraltar',
    value: 'Gibraltar'
  },
  {
    label: 'Greenland',
    value: 'Greenland'
  },
  {
    label: 'Gambia',
    value: 'Gambia'
  },
  {
    label: 'Guinea',
    value: 'Guinea'
  },
  {
    label: 'Guadeloupe',
    value: 'Guadeloupe'
  },
  {
    label: 'Equatorial Guinea',
    value: 'Equatorial Guinea'
  },
  {
    label: 'Greece',
    value: 'Greece'
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands'
  },
  {
    label: 'Guatemala',
    value: 'Guatemala'
  },
  {
    label: 'Guam',
    value: 'Guam'
  },
  {
    label: 'Guinea-Bissau',
    value: 'Guinea-Bissau'
  },
  {
    label: 'Czech Republic',
    value: 'Czech Republic'
  },
  {
    label: 'Guyana',
    value: 'Guyana'
  },
  {
    label: 'Hong Kong',
    value: 'Hong Kong'
  },
  {
    label: 'Heard Island and McDonald Islands',
    value: 'Heard Island and McDonald Islands'
  },
  {
    label: 'Honduras',
    value: 'Honduras'
  },
  {
    label: 'Croatia',
    value: 'Croatia'
  },
  {
    label: 'Haiti',
    value: 'Haiti'
  },
  {
    label: 'Hungary',
    value: 'Hungary'
  },
  {
    label: 'Indonesia',
    value: 'Indonesia'
  },
  {
    label: 'Ireland',
    value: 'Ireland'
  },
  {
    label: 'Israel',
    value: 'Israel'
  },
  {
    label: 'Isle of Man',
    value: 'Isle of Man'
  },
  {
    label: 'India',
    value: 'India'
  },
  {
    label: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory'
  },
  {
    label: 'Iraq',
    value: 'Iraq'
  },
  {
    label: 'Iran',
    value: 'Iran'
  },
  {
    label: 'Iceland',
    value: 'Iceland'
  },
  {
    label: 'Italy',
    value: 'Italy'
  },
  {
    label: 'Jersey',
    value: 'Jersey'
  },
  {
    label: 'Jamaica',
    value: 'Jamaica'
  },
  {
    label: 'Jordan',
    value: 'Jordan'
  },
  {
    label: 'Japan',
    value: 'Japan'
  },
  {
    label: 'Kenya',
    value: 'Kenya'
  },
  {
    label: 'Kyrgyzstan',
    value: 'Kyrgyzstan'
  },
  {
    label: 'Cambodia',
    value: 'Cambodia'
  },
  {
    label: 'Kiribati',
    value: 'Kiribati'
  },
  {
    label: 'Comoros',
    value: 'Comoros'
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'Saint Kitts and Nevis'
  },
  {
    label: 'North Korea',
    value: 'North Korea'
  },
  {
    label: 'South Korea',
    value: 'South Korea'
  },
  {
    label: 'Kosovo',
    value: 'Kosovo'
  },
  {
    label: 'Kuwait',
    value: 'Kuwait'
  },
  {
    label: 'Cayman Islands',
    value: 'Cayman Islands'
  },
  {
    label: 'Kazakhstan',
    value: 'Kazakhstan'
  },
  {
    label: 'Laos',
    value: 'Laos'
  },
  {
    label: 'Lebanon',
    value: 'Lebanon'
  },
  {
    label: 'Saint Lucia',
    value: 'Saint Lucia'
  },
  {
    label: 'Liechtenstein',
    value: 'Liechtenstein'
  },
  {
    label: 'Sri Lanka',
    value: 'Sri Lanka'
  },
  {
    label: 'Liberia',
    value: 'Liberia'
  },
  {
    label: 'Lesotho',
    value: 'Lesotho'
  },
  {
    label: 'Lithuania',
    value: 'Lithuania'
  },
  {
    label: 'Luxembourg',
    value: 'Luxembourg'
  },
  {
    label: 'Latvia',
    value: 'Latvia'
  },
  {
    label: 'Libya',
    value: 'Libya'
  },
  {
    label: 'Morocco',
    value: 'Morocco'
  },
  {
    label: 'Monaco',
    value: 'Monaco'
  },
  {
    label: 'Moldova',
    value: 'Moldova'
  },
  {
    label: 'Montenegro',
    value: 'Montenegro'
  },
  {
    label: 'Saint Martin',
    value: 'Saint Martin'
  },
  {
    label: 'Madagascar',
    value: 'Madagascar'
  },
  {
    label: 'Marshall Islands',
    value: 'Marshall Islands'
  },
  {
    label: 'Macedonia',
    value: 'Macedonia'
  },
  {
    label: 'Mali',
    value: 'Mali'
  },
  {
    label: 'Myanmar',
    value: 'Myanmar'
  },
  {
    label: 'Mongolia',
    value: 'Mongolia'
  },
  {
    label: 'Macao',
    value: 'Macao'
  },
  {
    label: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands'
  },
  {
    label: 'Martinique',
    value: 'Martinique'
  },
  {
    label: 'Mauritania',
    value: 'Mauritania'
  },
  {
    label: 'Montserrat',
    value: 'Montserrat'
  },
  {
    label: 'Malta',
    value: 'Malta'
  },
  {
    label: 'Mauritius',
    value: 'Mauritius'
  },
  {
    label: 'Maldives',
    value: 'Maldives'
  },
  {
    label: 'Malawi',
    value: 'Malawi'
  },
  {
    label: 'Mexico',
    value: 'Mexico'
  },
  {
    label: 'Malaysia',
    value: 'Malaysia'
  },
  {
    label: 'Mozambique',
    value: 'Mozambique'
  },
  {
    label: 'Namibia',
    value: 'Namibia'
  },
  {
    label: 'New Caledonia',
    value: 'New Caledonia'
  },
  {
    label: 'Niger',
    value: 'Niger'
  },
  {
    label: 'Norfolk Island',
    value: 'Norfolk Island'
  },
  {
    label: 'Nigeria',
    value: 'Nigeria'
  },
  {
    label: 'Nicaragua',
    value: 'Nicaragua'
  },
  {
    label: 'Netherlands',
    value: 'Netherlands'
  },
  {
    label: 'Norway',
    value: 'Norway'
  },
  {
    label: 'Nepal',
    value: 'Nepal'
  },
  {
    label: 'Nauru',
    value: 'Nauru'
  },
  {
    label: 'Niue',
    value: 'Niue'
  },
  {
    label: 'New Zealand',
    value: 'New Zealand'
  },
  {
    label: 'Oman',
    value: 'Oman'
  },
  {
    label: 'Panama',
    value: 'Panama'
  },
  {
    label: 'Peru',
    value: 'Peru'
  },
  {
    label: 'French Polynesia',
    value: 'French Polynesia'
  },
  {
    label: 'Papua New Guinea',
    value: 'Papua New Guinea'
  },
  {
    label: 'Philippines',
    value: 'Philippines'
  },
  {
    label: 'Pakistan',
    value: 'Pakistan'
  },
  {
    label: 'Poland',
    value: 'Poland'
  },
  {
    label: 'Andorra',
    value: 'Andorra'
  },
  {
    label: 'United Arab Emirates',
    value: 'United Arab Emirates'
  },
  {
    label: 'Afghanistan',
    value: 'Afghanistan'
  },
  {
    label: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda'
  },
  {
    label: 'Anguilla',
    value: 'Anguilla'
  },
  {
    label: 'Armenia',
    value: 'Armenia'
  },
  {
    label: 'Angola',
    value: 'Angola'
  },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'Saint Pierre and Miquelon'
  },
  {
    label: 'Pitcairn',
    value: 'Pitcairn'
  },
  {
    label: 'South Sudan',
    value: 'South Sudan'
  },
  {
    label: 'Sweden',
    value: 'Sweden'
  },
  {
    label: 'Singapore',
    value: 'Singapore'
  },
  {
    label: 'Saint Helena',
    value: 'Saint Helena'
  },
  {
    label: 'Slovenia',
    value: 'Slovenia'
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'Svalbard and Jan Mayen'
  },
  {
    label: 'Slovakia',
    value: 'Slovakia'
  },
  {
    label: 'Sierra Leone',
    value: 'Sierra Leone'
  },
  {
    label: 'San Marino',
    value: 'San Marino'
  },
  {
    label: 'Senegal',
    value: 'Senegal'
  },
  {
    label: 'Somalia',
    value: 'Somalia'
  },
  {
    label: 'Suriname',
    value: 'Suriname'
  },
  {
    label: 'Sao Tome and Principe',
    value: 'Sao Tome and Principe'
  },
  {
    label: 'El Salvador',
    value: 'El Salvador'
  },
  {
    label: 'Sint Maarten',
    value: 'Sint Maarten'
  },
  {
    label: 'Syria',
    value: 'Syria'
  },
  {
    label: 'Swaziland',
    value: 'Swaziland'
  },
  {
    label: 'Turks and Caicos Islands',
    value: 'Turks and Caicos Islands'
  },
  {
    label: 'Chad',
    value: 'Chad'
  },
  {
    label: 'French Southern Territories',
    value: 'French Southern Territories'
  },
  {
    label: 'Togo',
    value: 'Togo'
  },
  {
    label: 'Thailand',
    value: 'Thailand'
  },
  {
    label: 'Tajikistan',
    value: 'Tajikistan'
  },
  {
    label: 'Tokelau',
    value: 'Tokelau'
  },
  {
    label: 'East Timor',
    value: 'East Timor'
  },
  {
    label: 'Turkmenistan',
    value: 'Turkmenistan'
  },
  {
    label: 'Tunisia',
    value: 'Tunisia'
  },
  {
    label: 'Tonga',
    value: 'Tonga'
  },
  {
    label: 'Turkey',
    value: 'Turkey'
  },
  {
    label: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago'
  },
  {
    label: 'Tuvalu',
    value: 'Tuvalu'
  },
  {
    label: 'Taiwan',
    value: 'Taiwan'
  },
  {
    label: 'Tanzania',
    value: 'Tanzania'
  },
  {
    label: 'Ukraine',
    value: 'Ukraine'
  },
  {
    label: 'Uganda',
    value: 'Uganda'
  },
  {
    label: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands'
  },
  {
    label: 'United States',
    value: 'United States'
  },
  {
    label: 'Uruguay',
    value: 'Uruguay'
  },
  {
    label: 'Uzbekistan',
    value: 'Uzbekistan'
  },
  {
    label: 'Vatican',
    value: 'Vatican'
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines'
  },
  {
    label: 'Venezuela',
    value: 'Venezuela'
  },
  {
    label: 'British Virgin Islands',
    value: 'British Virgin Islands'
  },
  {
    label: 'U.S. Virgin Islands',
    value: 'U.S. Virgin Islands'
  },
  {
    label: 'Vietnam',
    value: 'Vietnam'
  },
  {
    label: 'Vanuatu',
    value: 'Vanuatu'
  },
  {
    label: 'Wallis and Futuna',
    value: 'Wallis and Futuna'
  },
  {
    label: 'Samoa',
    value: 'Samoa'
  },
  {
    label: 'Yemen',
    value: 'Yemen'
  },
  {
    label: 'Mayotte',
    value: 'Mayotte'
  },
  {
    label: 'South Africa',
    value: 'South Africa'
  },
  {
    label: 'Zambia',
    value: 'Zambia'
  },
  {
    label: 'Zimbabwe',
    value: 'Zimbabwe'
  },
  {
    label: 'Serbia and Montenegro',
    value: 'Serbia and Montenegro'
  },
  {
    label: 'Netherlands Antilles',
    value: 'Netherlands Antilles'
  },
  {
    label: 'Puerto Rico',
    value: 'Puerto Rico'
  },
  {
    label: 'Palestinian Territory',
    value: 'Palestinian Territory'
  },
  {
    label: 'Portugal',
    value: 'Portugal'
  },
  {
    label: 'Palau',
    value: 'Palau'
  },
  {
    label: 'Paraguay',
    value: 'Paraguay'
  },
  {
    label: 'Qatar',
    value: 'Qatar'
  },
  {
    label: 'Reunion',
    value: 'Reunion'
  },
  {
    label: 'Romania',
    value: 'Romania'
  },
  {
    label: 'Serbia',
    value: 'Serbia'
  },
  {
    label: 'Russia',
    value: 'Russia'
  },
  {
    label: 'Rwanda',
    value: 'Rwanda'
  },
  {
    label: 'Saudi Arabia',
    value: 'Saudi Arabia'
  },
  {
    label: 'Solomon Islands',
    value: 'Solomon Islands'
  },
  {
    label: 'Seychelles',
    value: 'Seychelles'
  },
  {
    label: 'Sudan',
    value: 'Sudan'
  }
]

export const availableLanguagesInOnboarding = [
  'english',
  'hindi',
  'bengali',
  'marathi',
  'telugu',
  'tamil',
  'gujarati',
  'malayalam',
  'kannada'
]

export const restrictedLanguages = [
  'English',
  'Hindi',
  'Bengali',
  'Marathi',
  'Telugu',
  'Tamil',
  'Gujarati',
  'Malayalam',
  'Kannada',
  'Assamese',
  'Odia',
  'Punjabi',
  'Sanskrit',
  'Urdu',
  'Arabic',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'Estonian',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hebrew',
  'Hungarian',
  'Italian',
  'Japanese',
  'Korean',
  'Mandarin Chinese',
  'Mongolian',
  'Norwegian',
  'Pashto',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Sinhalese',
  'Spanish',
  'Swahili',
  'Vietnamese'
]

export const writerLabels: { label: string; value: WriterLabel }[] = [
  { value: 'new', label: 'New' },
  { value: 'unresponsive', label: 'Unresponsive' }
]

type State = { label: string; value: string }

export const indiaStatesList: State[] = [
  {
    label: 'Andhra Pradesh',
    value: 'Andhra Pradesh'
  },
  {
    label: 'Arunachal Pradesh',
    value: 'Arunachal Pradesh'
  },
  {
    label: 'Assam',
    value: 'Assam'
  },
  {
    label: 'Bihar',
    value: 'Bihar'
  },
  {
    label: 'Chattisgarh',
    value: 'Chattisgarh'
  },
  {
    label: 'Delhi',
    value: 'Delhi'
  },
  {
    label: 'Goa',
    value: 'Goa'
  },
  {
    label: 'Gujarat',
    value: 'Gujarat'
  },
  {
    label: 'Haryana',
    value: 'Haryana'
  },
  {
    label: 'Himachal Pradesh',
    value: 'Himachal Pradesh'
  },
  {
    label: 'Jammu and Kashmir',
    value: 'Jammu and Kashmir'
  },
  {
    label: 'Jharkhand',
    value: 'Jharkhand'
  },
  {
    label: 'Karnataka',
    value: 'Karnataka'
  },
  {
    label: 'Kerala',
    value: 'Kerala'
  },
  {
    label: 'Lakshadweep Islands',
    value: 'Lakshadweep Islands'
  },
  {
    label: 'Madhya Pradesh',
    value: 'Madhya Pradesh'
  },
  {
    label: 'Maharashtra',
    value: 'Maharashtra'
  },
  { label: 'Manipur', value: 'Manipur' },
  { label: 'Meghalaya', value: 'Meghalaya' },
  { label: 'Mizoram', value: 'Mizoram' },
  { label: 'Nagaland', value: 'Nagaland' },
  { label: 'Odisha', value: 'Odisha' },
  { label: 'Pondicherry', value: 'Pondicherry' },
  { label: 'Punjab', value: 'Punjab' },
  { label: 'Rajasthan', value: 'Rajasthan' },
  { label: 'Sikkim', value: 'Sikkim' },
  { label: 'Tamil Nadu', value: 'Tamil Nadu' },
  { label: 'Telangana', value: 'Telangana' },
  { label: 'Tripura', value: 'Tripura' },
  { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
  { label: 'Uttarakhand', value: 'Uttarakhand' },
  { label: 'West Bengal', value: 'West Bengal' },
  {
    label: 'Andaman and Nicobar Islands',
    value: 'Andaman and Nicobar Islands'
  },
  { label: 'Chandigarh', value: 'Chandigarh' },
  {
    label: 'Dadra & Nagar Haveli and Daman & Diu',
    value: 'Dadra & Nagar Haveli and Daman & Diu'
  },
  { label: 'Ladakh', value: 'Ladakh' },
  { label: 'Other Territory', value: 'Other Territory' }
]
